module.exports = __webpack_public_path__ + "static/vet-59399bbb9c608880cc56104f50d59d9e.png";